<template>
  <div id="banner"
       class="banner"
       :class="{'banner-active': isActive}">
    <div class="alert"
         :class="`alert-${store.banner.type}`">
      {{ store.banner.message }}
    </div>
  </div>
</template>

<script>
  import store from '../config/store'

  export default {
    data: () => ({
      store
    }),

    computed: {
      isActive () {
        return store.banner.active
      }
    },

    watch: {
      isActive () {
        if (this.isActive) {
          setTimeout(() => {
            store.banner.active = false
          }, 5000)
        }
      }
    },
  }
</script>

<style scoped>
  .banner {
    position: fixed;
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
    top: -60px;
    transition: top 1s ease;
  }

  .banner-active {
    top: 30px;
    transition: top 1s ease;
  }


</style>